import axios from 'axios';

export default {
    getGroupInfo(context, groupId, week, term) {
        var options = {
            url: window.apiUrl + '/group/' + groupId + '?week=' + week + '&term=' + term,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getGroups(context) {
        var options = {
            url: window.apiUrl + '/all-groups',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getInfo(context, studentId, termId) {
        var options = {
            url: window.apiUrl + '/student/' + studentId + '?term='+termId,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getProgression(context, uuid, week, instances) {
        
        let url = window.apiUrl + '/progression/' + uuid + '?week=' + week;
        
        if (instances) url += '&instances=' + instances;

        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    get(context) {
        var options = {
            url: window.apiUrl + '/students',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    evaluate(context, data) {
        var options = {
            method: 'PUT',
            url: window.apiUrl + '/evaluation',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data
            
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/students/index.js